import { Link } from 'react-router-dom'

import Button from '@src/components/buttons/Button'
import { DiscordIcon } from '@src/components/icons/SocialIcons'
import TelegramIcon from '@src/components/icons/Telegram'
import TwitterIcon from '@src/components/icons/Twitter'
import * as PATH from '@src/configs/paths'

const Footer = () => {
    const name = window.location.href.includes('hourglass') ? 'Hourglass' : 'Mach'
    const auditLink = 'https://drive.google.com/file/d/1zwcpFp-Mkjiz9f77Q5oWr8jKrlfwvVmL/view'
    const contact = 'mailto:support@tristero.xyz'
    const feedbackLink =
        'https://docs.google.com/forms/d/1j2jOzuAibZA3-5g84HNYEyG8c8plgkJ1-Nf7_pAnC1Q/viewform?edit_requested=true'
    const twitterLink = 'https://try.mach.exchange/website_to_twitter'
    const telegramLink = 'https://t.me/mach_exchange'
    const discordLink = 'https://discord.gg/mach'

    return (
        <footer className='container flex flex-col items-center space-y-4 py-8 font-geist tracking-tightest md:flex-row md:justify-between md:space-y-0 md:py-16'>
            <div className='flex items-center space-x-6 text-sm text-mach-sub-text'>
                <Link to={auditLink} target='_blank' className='hover:text-white'>
                    Audit
                </Link>
                <Link to={contact} className='hover:text-white'>
                    Contact
                </Link>
                <Link to={feedbackLink} target='_blank' className='hover:text-white'>
                    Bug & Feedback Form
                </Link>
                <Link to={PATH.STATS} className='hover:text-white'>
                    Stats
                </Link>
            </div>
            <div className='flex items-center space-x-2'>
                <span className='pr-1 text-sm font-semibold'>
                    Copyright © {new Date().getFullYear()} {name} Protocol
                </span>
                <Link
                    className='flex h-6 min-w-6 items-center justify-center rounded-full bg-[#26272B]'
                    to={twitterLink}
                    target='_blank'
                >
                    <TwitterIcon className='h-[14px] w-[14px]' />
                </Link>
                <Link
                    className='flex h-6 min-w-6 items-center justify-center rounded-full bg-[#26272B]'
                    to={telegramLink}
                    target='_blank'
                >
                    <TelegramIcon className='h-4 w-4' />
                </Link>
                <Link to={discordLink} target='_blank'>
                    <Button className='flex h-6 w-fit items-center justify-center gap-1 rounded-full !bg-[#26272B] !px-2 !py-3.5 text-[15px] md:!px-3'>
                        <DiscordIcon className='h-4 w-4' />
                        <span className='hidden md:inline'>Support</span>
                    </Button>
                </Link>
            </div>
        </footer>
    )
}

export default Footer
